import script from "./DropDownAlarms.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropDownAlarms.vue?vue&type=script&setup=true&lang=ts"

import "./DropDownAlarms.vue?vue&type=style&index=0&id=42cf20c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cf20c2"]])

export default __exports__